module.exports = __webpack_public_path__ + "img/camera_hide.cb0cfd66.svg";